export const IMAGES = {
  hero: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDBOO5RENNoPai2Av8JA02qhAHWMVM-fVqh09C5bZhyGQL0j82PA36yOK29PqadsP7E08wH-wmzRiy0w9HAIeDhr-mnqEJaWEM_j4c02rbii59Bdr0Sk0LQVW2hfBr6v7XKq-Nu0_CM9VXQyzc1VJHxdT5aEJgWKE8CNl8PrfJTzLtIzm4hfvqwtUJjb5SJwRJg_49jgoV_z56epLr9uXfPazGt8jutF3ldJ6xQEac5AFukjhnmWajmX91D9Q9tsORAvkoqcZcAHcb-',
  kottu: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAZi5COhjpLs_CD45T_UXvgjhLnqNqvXzX39DV-HGUSCEhdlI8GZDl1a7bki09I_joYHyVIrAEteoMKp98CR3IfypE2oATFG-yle4lKg-OSQyxYxJQGKmE7FECsFY_HE-_L2UeIjWPGV4djuI0XW1VNkSEjLKUM5jlGzEK-8SR7eG84pN6_W4Vi76Il895IivQhGHf5DbeA0ryg78KUYSmzfguw3GfKZvy4E0K-q0LPRExdEeW8ZQHAwT_j-ovVrXvQnTecGP_bUdkq',
  hoppers: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDv-GJq5QJzZ06_LTyT2bmp_8oET0mem68HuM_pS3E0TX2O4VWbIkkAVr1lkvH1zjDkF3IEGwWAP4yzvUPJ7D4u6TY5FjhZC0e5rQlzBk14nlVtlTXTS2dwap2RQpYr2-OvgpmAan-asxKpEqu84a4Cez7jqa0tgz7_L6BNOP6DS7Mesuzt-x_wWngvgs9n5o-WCzRBsB9HpcwtdxsJ3nnGcJwsQUTML5sVrKfaNDwCNg9kDTA6rdiTTXUy5bTs4nkK2le0_Es7jE9f',
  pork: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCaNpl2bvbRa9Zw3aUS7QQEpPvRQYBl2bacewouUQmfmznMmOA8-NoekweVH-V7RP7LTJo55u_vvFZX4DeIfya_NzTRKcHySQ_d16f4k9lQKlTCnV35XB1e2j7NXfdJl9XNijH4cMAxDoorWrueJTBOvJ-FVpdArA90axFQuC-vRGcwL6jABBY_KG4hmXoAmKGrutrW-H7wxv7ez15z_fGC6ybQK8u5NiLf7J8w7pRERMRAMCmEj5OKv-Cz6ODxU4jOPSq7KJdwLadc',
  curry: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDF2gNda4qV-YVN5Zk4RcPPzFPC5v-O973JVAtHFQ6Oyxc1FGji3zgeQINtSnaVNGmjMhz3rNBVXbJd_y_tKprUyLgxd3gdR_fjrrFRxFR5N1PBlS1yJHywKlBJh_GTXiOIBVNtmecGJ_RpSSwCfe5FT8Zdlua_jHfT8bSWLDG_6dik_txQ9FxM7WCnbXKtIPBL6c3GnINBeF0xbDGxxi-vM5eBpVZPGExKR1jqxkpgRPN2ZfpS66etZLGO_-kRmrQGDP8aJeKgLM30',
  map: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDvk0VPXpt0PZHaAcL63t_sRQAPPDvaDQVrkWUWlPErKonlrSeQVjsNgGi9lVsZ53ur0vO48wJjj63MnE5E7oE8kJYPcRMlIMaGdM9UlmpZRMqu1JGcRrRjnmoRpdp_kpP1HZcGmvX_ONIQDi4vY2Is4xM2wleRz-leeuBzJ3vxlLSYzhX6B0me9yQNg0LOolb213Z5sEXXyjgMHEM2twUM6of8WI9o-qX5aNyUbwP-NBmvQx2PtaesKougC9SiNViNFMSAunAwxRAx',
  chef: 'https://lh3.googleusercontent.com/aida-public/AB6AXuC81H3un7z7xJC37o4PE4zTeyVoZLQB10Mi1OMZFexCC8V_oLMuccy5768f8AD3xuAIuo-TurqoFkEub8rlk92zscTpzXgeLKcvKz8KLI1P47SECdl8n3u5yKSiC_o7RIiOh4hzSTrkCzLR2VAXT3q1V_7pXgwY58PTcweE2sdr0MWphRpvMB0nOCaf57mHGjAMSyrCPZ6gS-0Rc4HMKEQcCwZ2g0-o_VHTn3NprRBrEFicAG0zPwYIwuUk3QP36Ob2mwhNFPQcGhgi',
};

export const SPECIALS = [
  { nameKey: 'sc1.name', descKey: 'sc1.desc', price: '13 €', stars: 4.5, img: 'kottu' },
  { nameKey: 'sc2.name', descKey: 'sc2.desc', price: '3 €',  stars: 5,   img: 'hoppers' },
  { nameKey: 'sc3.name', descKey: 'sc3.desc', price: '14 €', stars: 3,   img: 'pork' },
  { nameKey: 'sc4.name', descKey: 'sc4.desc', price: '13 €', stars: 5,   img: 'curry' },
];

export const MENU = {

  // ── BUFFET & SALADS ──────────────────────────────────────────────────────
  buffet: {
    heroImg: 'curry', heroPrice: '13 €', spice: 0, tagKey: 'tag.special',
    heroName: 'Sri Lankan Buffet',
    heroDesc: 'Riz vapeur, currys de viande et de légumes du jour, sambols maison · Déjeuner uniquement',
    heading: 'Salades / Salads',
    subtitle: 'Fresh seasonal salads · Sri Lankan style',
    simple: [
      { name: 'Beetroot Mixed Salad',       desc: 'Beetroot, cucumber, dill onion, green chilli, lemon juice, pepper', price: '8 €' },
      { name: 'Chicken Caesar Salad',                                                                                    price: '8 €' },
      { name: 'Sri Lankan Gotokola Salad',  desc: 'Bal sauce, dry fish, lemon juice, coconut',                          price: '8 €' },
      { name: 'Karunella Salad',            desc: 'Onions, dry fish, lemon juice, green chilli',                        price: '12 €' },
    ],
  },

  // ── FRIED RICE ───────────────────────────────────────────────────────────
  rice: {
    heroImg: 'curry', heroPrice: '13 €', spice: 1, tagKey: 'tag.special',
    heroName: 'Chicken Fried Rice',
    heroDesc: 'Poulet, oignon, carotte, poireaux, choux, œufs, épices Sri Lankaises',
    heading: 'Fried Rice',
    subtitle: 'Rice & Fried Rice · All served with sambol',
    dishes: [
      { name: 'Veg Fried Rice',      desc: 'Légumes, oignon, carotte, poireaux, choux, œufs, épices',                 price: '10 €', stars: 4,   img: 'hoppers' },
      { name: 'Egg Fried Rice',      desc: 'Œuf, oignon, carotte, poireaux, choux, épices Sri Lankaises',              price: '12 €', stars: 4,   img: 'hoppers' },
      { name: 'Beef Fried Rice',     desc: 'Bœuf, oignon, carotte, poireaux, choux, œufs, épices Sri Lankaises',      price: '14 €', stars: 4.5, img: 'pork' },
      { name: 'Mutton Fried Rice',   desc: 'Mutton, oignon, carotte, poireaux, choux, œufs, épices Sri Lankaises',    price: '14 €', stars: 4.5, img: 'pork' },
      { name: 'Seafood Fried Rice',  desc: 'Encornets, crevettes, poisson, oignon, carotte, poireaux, choux, œufs',   price: '15 €', stars: 5,   img: 'curry' },
      { name: 'Nasi Goreng',         desc: 'Riz frit style indonésien, légumes, œufs, épices, sauce soja',             price: '15 €', stars: 4.5, img: 'curry' },
      { name: 'Mixed Fried Rice',    desc: 'Bœuf, poulet, mutton, oignon, carotte, poireaux, choux, œufs',            price: '15 €', stars: 5,   img: 'curry' },
    ],
  },

  // ── KOTTU ────────────────────────────────────────────────────────────────
  kottu: {
    heroImg: 'kottu', heroPrice: '13 €', spice: 3, tagKey: 'tag.bestseller',
    heroName: 'Chicken Kottu',
    heroDesc: 'Roti haché sauté avec poulet, légumes frais, œufs et épices sri lankaises',
    heading: 'Kottu Roti',
    subtitle: "Le plat national sri lankais · roti haché, légumes, épices",
    dishes: [
      { name: 'Veg Kottu',      desc: 'Oignon, carotte, poireaux, choux, œufs, piment vert, épices',                  price: '10 €', stars: 4.5, img: 'kottu' },
      { name: 'Egg Kottu',      desc: 'Œuf, oignon, carotte, poireaux, choux, piment vert, épices',                    price: '12 €', stars: 4.5, img: 'kottu' },
      { name: 'Fish Kottu',     desc: 'Poisson, oignon, carotte, poireaux, choux, piment vert',                        price: '14 €', stars: 4.5, img: 'curry' },
      { name: 'Beef Kottu',     desc: 'Bœuf, oignon, carotte, poireaux, choux, piment vert, œufs',                    price: '14 €', stars: 5,   img: 'pork' },
      { name: 'Mutton Kottu',   desc: 'Mutton, oignon, carotte, poireaux, choux, piment vert, œufs',                  price: '15 €', stars: 5,   img: 'pork' },
      { name: 'Seafood Kottu',  desc: 'Encornets, crevettes, poisson, oignon, carotte, poireaux',                      price: '15 €', stars: 5,   img: 'kottu' },
      { name: 'Dolphin Kottu',  desc: 'Poisson dauphin, oignon, carotte, poireaux, choux, œufs, piment vert',         price: '15 €', stars: 4.5, img: 'curry' },
    ],
  },

  // ── DEVILLED DISHES ──────────────────────────────────────────────────────
  devilled: {
    heroImg: 'pork', heroPrice: '13 €', spice: 3,
    heroName: 'Devilled Chicken',
    heroDesc: 'Poulet, oignon, poivron cubanelle vert, sauce soja, épices Sri Lankaises',
    heading: 'Devilled Dishes',
    subtitle: 'Spicy Sri Lankan Stir Fry · épicé, savoureux, généreux',
    dishes: [
      { name: 'Devilled Fish',         desc: 'Poisson, oignon, poivron cubanelle vert, sauce soja, épices',             price: '14 €', spice: 2, img: 'curry' },
      { name: 'Devilled Seafood',      desc: 'Fruits de mer, oignon, poivron cubanelle vert, sauce soja, épices',       price: '14 €', spice: 3, img: 'hoppers' },
      { name: 'Devilled Prawn',        desc: 'Crevettes, oignon, poivron cubanelle vert, sauce soja, épices',           price: '14 €', spice: 2, img: 'curry' },
      { name: 'Devilled Garlic Beef',  desc: 'Bœuf à l\'ail, oignon, poivron cubanelle vert, sauce soja, épices',      price: '14 €', spice: 3, img: 'pork' },
      { name: 'Roasted Pork',          desc: 'Porc rôti, épices Sri Lankaises, oignon, piment',                         price: '14 €', spice: 2, img: 'pork' },
    ],
  },

  // ── CHAPSUEY ─────────────────────────────────────────────────────────────
  chapsuey: {
    heading: 'Chapsuey',
    subtitle: 'Hot Pot · Beef, Mutton, Chicken ou Seafood · servi avec riz',
    simple: [
      { name: 'Mix – Beef + Mutton + Chicken',      price: '16 €' },
      { name: 'Mix – Sea Food',                     price: '16 €' },
      { name: 'Veg Chapsuey (with Rice)',            price: '13 €' },
      { name: 'Chicken Chapsuey (with Rice)',        price: '14 €' },
      { name: 'Beef Chapsuey (with Rice)',           price: '14 €' },
    ],
  },

  // ── PIZZA & BURGERS ──────────────────────────────────────────────────────
  pizza: {
    heading: 'Burgers & Pizza',
    subtitle: 'Burgers servis avec frites · Burgers served with fries',
    simple: [
      { name: 'Cheeseburger',      desc: 'Served with fries',                                                           price: '12 €' },
      { name: 'Pizza Gemiya',      desc: 'Cheese, peppers, red sauce, chicken, beef, mutton, curry leaves',             price: '12 €' },
      { name: 'Pizza Margherita',  desc: 'Cheese, oregano',                                                             price: '10 €' },
    ],
  },

  // ── HOPPERS, PITTU & EXTRAS ──────────────────────────────────────────────
  sides: {
    heading: 'Hoppers & Pittu',
    subtitle: 'Appam, crêpes de riz fermenté · Servi avec curry de lait de coco',
    simple: [
      { name: 'Egg Hopper',           price: '3 €' },
      { name: 'Milk Hopper',          price: '3 €' },
      { name: 'Cheese Hopper',        price: '3 €' },
      { name: 'Sausage Hopper',       price: '3 €' },
      { name: 'Chicken Curry Pittu',  desc: 'Served with coconut milk curry',                                           price: '12 €' },
      { name: 'Fish Curry Pittu',     desc: 'Served with coconut milk curry',                                           price: '12 €' },
      { name: '— Drinks —',           desc: '' },
      { name: 'Mango Juice',          price: '4 €' },
      { name: 'Passion Fruit Juice',  price: '4 €' },
      { name: 'Soft Drinks',          price: '2.50 €' },
      { name: 'Iced Tea (Lemon)',     price: '3.50 €' },
      { name: '— Desserts —',         desc: '' },
      { name: 'Wadappan',             price: '4 €' },
      { name: 'Coconut Pudding',      price: '4 €' },
      { name: 'Ice Cream (Vanilla)',  price: '4 €' },
    ],
  },

};
